import { render, staticRenderFns } from "./privacypolicy.vue?vue&type=template&id=176ece16&"
import script from "./privacypolicy.vue?vue&type=script&lang=js&"
export * from "./privacypolicy.vue?vue&type=script&lang=js&"
import style0 from "./privacypolicy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports